<template>
  <div class="mainWrapper">
    <Hero />
    <Grid />
    <Quote />
    <Banner />
    <Collaboration />
    <Story />
    <Contributions />
  </div>
</template>


<script>
import Hero from "../components/Hero.vue";
import Grid from "../components/Grid.vue";
import Story from "../components/Story.vue";
import Banner from "../components/Banner.vue";
import Quote from "../components/Quote.vue";
import Collaboration from "../components/Collaboration.vue";
import Contributions from "../components/Contributions.vue";

export default {
  name: "Main",
  components: {
    Hero,
    Grid,
    Story,
    Banner,
    Quote,
    Collaboration,
    Contributions,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
.mainWrapper {
  margin-top: 87px;
  font-family: "SofiaProRegular";
  width: 100%;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@media only screen and (min-width: 1200px) and (max-width: 1448px) {
  .mainWrapper {
  }
}

@media only screen and (min-width: 1029px) and (max-width: 1199px) {
  .mainWrapper {
  }
}

@media only screen and (min-width: 823px) and (max-width: 1028px) {
  .mainWrapper {
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  .mainWrapper {
  }
}

@media only screen and (min-width: 375px) and (max-width: 515px) {
  .mainWrapper {
    width: 100%;
    margin-top: 0px;
  }
}
</style>
